module.exports = __webpack_public_path__ + "img/about-bg.11d1c10b.png";